import OutlineNine from '@assets/icons/outline-nine.svg'
import { Icon } from './Icon'

export const OutlineNineIcon = Icon(OutlineNine)
